// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AdminSubType } from './admin-sub-type';
import { Lookup } from './lookup';
import { MergeTemplate } from './merge-template';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class MergeTemplateCategory extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  mergeTemplateCategoryId!: number;
  adminSubTypeId?: number;
  createdBy!: string;
  createdDate!: Date;
  datasource?: string;
  datasourceLookupId?: number;
  defaultSelector?: number;
  description!: string;
  parentMergeTemplateCategoryId?: number;
  savePath?: string;
  systemFlags?: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  adminSubType!: AdminSubType;
  datasourceLookup!: Lookup;
  inverseParentMergeTemplateCategory!: MergeTemplateCategory[];
  mergeTemplates!: MergeTemplate[];
  parentMergeTemplateCategory!: MergeTemplateCategory;
}

